namespace TabAurous.Retail {
    export interface POSSalesReceiptForm {
        ModeId: Serenity.LookupEditor;
        LedgerId: Serenity.LookupEditor;
        Amount: Serenity.DecimalEditor;
        TempAmount: Serenity.DecimalEditor;
        RefNo: Serenity.StringEditor;
        Scheme: Serenity.LookupEditor;
        Total: Serenity.DecimalEditor;
        Balance: Serenity.DecimalEditor;
        BankId: Serenity.LookupEditor;
        ChequeNo: Serenity.IntegerEditor;
        ChequeDate: Serenity.DateEditor;
        Denominations: POSSalesReceiptDetailsEditor;
    }

    export class POSSalesReceiptForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.POSSalesReceipt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!POSSalesReceiptForm.init)  {
                POSSalesReceiptForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DateEditor;
                var w5 = POSSalesReceiptDetailsEditor;

                Q.initFormType(POSSalesReceiptForm, [
                    'ModeId', w0,
                    'LedgerId', w0,
                    'Amount', w1,
                    'TempAmount', w1,
                    'RefNo', w2,
                    'Scheme', w0,
                    'Total', w1,
                    'Balance', w1,
                    'BankId', w0,
                    'ChequeNo', w3,
                    'ChequeDate', w4,
                    'Denominations', w5
                ]);
            }
        }
    }
}
